module.exports = __webpack_public_path__ + "img/flatris.f695528b.gif";